import { Box } from "@itandi/itandi-bb-ui";
import type React from "react";
import Styles from "./statuses.module.scss";

export const Finished: React.FC = () => (
	<div>
		<h3 className={Styles.Title}>完了しました</h3>
		<Box marginY={16}>
			<p>すべての工事工程が完了しました。</p>
		</Box>
	</div>
);
